// src/communicator/boek.js
// NOTE: keeps your working fetch pattern (no headers), and supports both {data:{...}} and [ {...} ] shapes.

export async function getBookByIsbn(isbnRaw) {
  const urlAPI = process.env.REACT_APP_URL_API; // e.g. http://api.localhost
  const urlEndpoint = urlAPI + '/catalog/getBookByIsbn.php';

  // Normalize to 13 digits (taken from URL param or caller)
  const isbn13 = String(isbnRaw || '').replace(/\D/g, '').slice(-13);
  if (isbn13.length !== 13) {
    console.warn('getBookByIsbn: invalid ISBN param:', isbnRaw);
    return null;
  }

  const postData = { isbn13 };

  try {
    const response = await fetch(urlEndpoint, {
      method: 'POST',
      body: JSON.stringify(postData),
      // IMPORTANT: keep headers empty (matches your ?working? version)
      headers: new Headers({}),
    });

    // Some backends return JSON, some return text; parse safely
    let responseJson;
    try {
      responseJson = await response.json();
    } catch (_) {
      // Fallback: try reading text then JSON.parse manually (rare)
      const raw = await response.text();
      try { responseJson = JSON.parse(raw); } catch (e) {
        console.error('getBookByIsbn: cannot parse response', e);
        return null;
      }
    }

    // Support both shapes:
    // 1) { data: {...} }
    if (responseJson && responseJson.data && typeof responseJson.data === 'object') {
      return responseJson.data;
    }
    // 2) [ {...} ]
    if (Array.isArray(responseJson) && responseJson.length > 0) {
      return responseJson[0];
    }

    // Nothing matched
    console.warn('getBookByIsbn: unexpected payload', responseJson);
    return null;
  } catch (error) {
    console.error('SbC fetch error getBookByIsbn:', error?.message || error);
    return null;
  }
}
